module.exports = __webpack_public_path__ + "8b98def7476684934a3327bf0d75776d.png";